import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SeoFooter = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    company: '',
    business: 'none',
    city: '',
    email: '',
    message: '',
    policyConsent: true,
  });
  
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const siteKey = "6LcuJ9QmAAAAAGeBZPkD4Am3FwfPo7fJoowZQpvI"; // from old PHP
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(siteKey, { action: 'submit' }).then(async (token) => {
            const submissionData = {
              ...formData,
              to: "leads@grank.co.in",
              subject: "Enquiry For G-Rank",
              cc: "suresh@grank.co.in, singam@grank.co.in",
              bcc: "server@grank.co.in",
              url: window.location.href,
              token
            };

            const response = await fetch("https://server.grank.co.in/send-email", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(submissionData),
            });

            if (response.ok) {
              // Clean up Bootstrap modal backdrop before React Router navigates
              const backdrops = document.querySelectorAll('.modal-backdrop');
              backdrops.forEach(backdrop => backdrop.remove());
              document.body.classList.remove('modal-open');
              document.body.style.paddingRight = '';

              navigate(`/seo-thankyou?email=${encodeURIComponent(formData.email)}`);
            } else {
              console.error("Error submitting form");
            }
            setLoading(false);
          }).catch(err => {
            console.error(err);
            setLoading(false);
          });
        });
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <>
      <section className="footer-contact">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <h2 className="elevate">Want to Elevate Your Brand? Get in Touch.</h2>
            </div>

            <div className="contact-us-form-mobile enqr">
              <form role="form" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="contact-flex">
                      <input className="floating-label" placeholder="Name" type="text" name="name" required value={formData.name} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="contact-flex">
                      <input placeholder="Phone" type="tel" name="phone" required value={formData.phone} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="contact-flex">
                      <input placeholder="Company Name" type="text" name="company" required value={formData.company} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="contact-flex">
                      <select name="business" className="contact-select-div" required value={formData.business} onChange={handleChange}>
                        <option value="none">Type Of Business</option>
                        <option value="B2B">B2B</option>
                        <option value="B2C">B2C</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="contact-flex">
                      <input placeholder="City" type="text" name="city" required value={formData.city} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="contact-flex">
                      <input placeholder="Email" type="email" name="email" required value={formData.email} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="contact-flex">
                      <textarea placeholder="Message" name="message" value={formData.message} onChange={handleChange}></textarea>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="chbox-div">
                      <input type="checkbox" className="chbox" name="policyConsent" required checked={formData.policyConsent} onChange={handleChange} />
                      I hereby authorize to send notifications on SMS/Messages/Promotional/Informational Messages
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <input className="sbmt" type="submit" value={loading ? "Submitting..." : "Submit Now"} disabled={loading} />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <footer id="pt-footer">
        <div className="pt-footer-style-1">
          <div className="footer-back">
            <div className="container py-4">
              <div className="footer-top-brand">
                <a href="https://www.grank.co.in/">
                  <img src="/seo-assets/photos/g-rank-white-logo.png" alt="G-Rank Digital Marketing Agency" title="G-Rank" />
                </a>
                <div style={{ color: '#94a3b8', fontSize: '0.9rem', fontStyle: 'italic' }}>
                  Your Knowledge &amp; Commitment Partner Since 2010
                </div>
              </div>

              <div className="row">
                <div className="col-lg-3 col-md-3">
                  <div className="widget">
                    <h4 className="footer-title">Our Products</h4>
                    <div className="menu-our-products-container">
                      <ul id="menu-our-products" className="menu">
                        <li className="menu-item"><a href="https://www.grank.co.in/branding-agency">Branding</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/performance-marketing-company">Performance Marketing</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/organic-marketing-agency">Organic Marketing</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/creative-content-agency">Creative &amp; Content</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/social-media-agency">Social Media</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/web-development-agency">Web Development</a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-3">
                  <div className="widget">
                    <h4 className="footer-title">About G-rank</h4>
                    <div className="menu-about-mrcretive-container">
                      <ul id="menu-about-mrcretive" className="menu">
                        <li className="menu-item"><a href="https://www.grank.co.in/industries">Industries</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/case-studies">Case Studies</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/career">Careers</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/contact">Contact</a></li>
                        <li className="menu-item"><a href="https://www.grank.co.in/blog">Blogs</a></li>
                        <li className="menu-item"><a href="/sitemap">Sitemap</a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-3">
                  <div className="widget">
                    <h4 className="footer-title">Hyderabad</h4>
                    <div className="row">
                      <div className="col-sm-12">
                        <ul className="pt-contact">
                          <li><i className="fa-solid fa-location-dot"></i><span>1-8-382, Ground Floor, Queen's Plaza, Begumpet, Hyderabad, Telangana – 500003</span></li>
                          <li><a href="tel:+919177722097" title="Call Hyderabad Office"><i className="fa-solid fa-phone"></i><span>+91 9177722097</span></a></li>
                          <li><a href="mailto:leads@grank.co.in" title="Email G-Rank"><i className="fa-solid fa-envelope"></i><span>leads@grank.co.in</span></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-3">
                  <div className="widget">
                    <h4 className="footer-title">Bangalore</h4>
                    <div className="row">
                      <div className="col-sm-12">
                        <ul className="pt-contact">
                          <li><i className="fa-solid fa-location-dot"></i><span>Urban Vault Citrine, 2nd Floor, No-43 New Airport Road, NH 7, Outer Ring Rd, Sahakar Nagar, Bengaluru, Karnataka, India - 560092</span></li>
                          <li><a href="tel:+919686442800" title="Call Bangalore Office"><i className="fa-solid fa-phone"></i><span>+91 9686442800</span></a></li>
                          <li><a href="mailto:leads@grank.co.in" title="Email G-Rank"><i className="fa-solid fa-envelope"></i><span>leads@grank.co.in</span></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-back2">
            <div className="footer-white-bg-padding">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="row">
                    <div className="col-sm-12 col-md-12">
                      <div className="row">
                        <div className="col-4"><img src="/seo-assets/photos/google-partner-big.png" alt="G-Rank" className="img-fluid footer-icon-img" title="Google Partner" /></div>
                        <div className="col-4"><img src="/seo-assets/photos/meta-partner-big.png" alt="G-Rank" className="img-fluid footer-icon-img2" title="Meta Partner" /></div>
                        <div className="col-4"><img src="/seo-assets/photos/google-workspace-big.png" alt="G-Rank" className="img-fluid footer-icon-img" title="Google Workspace" /></div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12">
                      <div className="row">
                        <div className="col-4"><img src="/seo-assets/photos/google-cloud-big.png" alt="G-Rank" className="img-fluid footer-icon-img2" title="google cloud" /></div>
                        <div className="col-4"><img src="/seo-assets/photos/rediff-big.png" alt="G-Rank" className="img-fluid footer-icon-img" title="rediff" /></div>
                        <div className="col-4"><img src="/seo-assets/photos/microsoft-logo.png" alt="G-Rank" className="img-fluid footer-icon-img" title="microsoft" /></div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12">
                      <div className="row">
                        <div className="col-6">
                          <a href="https://www.designrush.com/agency/profile/g-rank-digital-services-private-limited" target="_blank" rel="noreferrer">
                            <img src="/seo-assets/photos/design-rush.png" alt="SMM Agency On DesignRush" className="img-fluid footer-icon-img-dr" title="SMM Agency On DesignRush" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-8 col-md-6 mt50">
                  <div className="widget">
                    <div className="row">
                      <div className="col-sm-12 text-align-div">
                        <img src="/seo-assets/photos/g-rank-white-logo.png" className="pt-footer-logo" alt="gym-footer-logo" title="logo" />
                        <p className="grank-title">G-Rank - Digital Marketing Partner an ISO 9001:2008 certified company, established in 2010, is leading Digital Marketing company. We strategize and deliver pertinent digital marketing campaigns that adds value to the client`s bottom line. We are a proud holder of Google Certified Partnership since 2011.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-back3"></div>
          <div className="pt-copyright-footer">
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-5 col-lg-5 align-self-center">
                  <span className="pt-copyright"><a href="#">Copyright © 2025 G-Rank Digital Services Private Limited</a></span>
                </div>
                <div className="col-12 col-md-2 col-lg-4 align-self-center terms-policy-align">
                  <a className="teams-link" href="https://www.grank.co.in/terms-conditions" style={{ color: 'rgb(255, 255, 255)' }}>Terms &amp; Conditions</a>
                  <a className="teams-link" href="https://www.grank.co.in/privacy-policy" style={{ color: 'rgb(255, 255, 255)' }}>Privacy Policy</a>
                </div>
                <div className="col-12 col-md-5 col-lg-3">
                  <div className="pt-footer-social">
                    <ul>
                      <li><a href="https://www.youtube.com/channel/UCAuK0EC-TmLLHVSmrjxMnIA" target="_blank" rel="noreferrer"><i className="fa-brands fa-youtube"></i></a></li>
                      <li><a href="https://www.facebook.com/Grank.India" target="_blank" rel="noreferrer"><i className="fa-brands fa-square-facebook"></i></a></li>
                      <li><a href="https://www.instagram.com/grank.india/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
                      <li><a href="https://www.linkedin.com/company/g-rank-digital-marketing-company/" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin"></i></a></li>
                      <li><a href="https://twitter.com/Grank_India/" target="_blank" rel="noreferrer"><i className="fa-brands fa-x-twitter"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Enquire Now Modal */}
      <div className="modal" id="myModalEnquire">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header enqdiv">
              <h4 className="modal-title">Enquire Now</h4>
              <button type="button" className="close" data-dismiss="modal">&times;</button>
            </div>

            {/* Modal body */}
            <div className="modal-body">
              <div className="popup-section">
                <div className="contact-us-form-mobile enqr">
                  <form role="form" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="contact-flex">
                          <input className="floating-label" placeholder="Name" type="text" name="name" required value={formData.name} onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="contact-flex">
                          <input placeholder="Phone" type="tel" name="phone" required value={formData.phone} onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="contact-flex">
                          <input placeholder="Company Name" type="text" name="company" required value={formData.company} onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="contact-flex">
                          <select name="business" className="contact-select-div" required value={formData.business} onChange={handleChange}>
                            <option value="none">Type Of Business</option>
                            <option value="B2B">B2B</option>
                            <option value="B2C">B2C</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="contact-flex">
                          <input placeholder="City" type="text" name="city" required value={formData.city} onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="contact-flex">
                          <input placeholder="Email" type="email" name="email" required value={formData.email} onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="contact-flex">
                          <textarea placeholder="Message" name="message" value={formData.message} onChange={handleChange}></textarea>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="chbox-div">
                          <input type="checkbox" className="chbox" name="policyConsent" required checked={formData.policyConsent} onChange={handleChange} />
                          I hereby authorize to send notifications on SMS/Messages/Promotional/Informational Messages
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <input className="sbmt" type="submit" value={loading ? "Submitting..." : "Submit Now"} disabled={loading} />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SeoFooter;
